<app-page-shell>
  <app-page-hero
    eyebrow="Transport Planning"
    title="Cross-Dock Orchestrations"
    subtitle="Control-tower view for split releases, warehouse transfers, and gated final dispatches.">
    <div actions>
      <p-button label="Release Pool" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/transport-planning/releases"></p-button>
      <p-button label="Refresh" icon="pi pi-refresh" (onClick)="load()"></p-button>
    </div>
  </app-page-hero>

  <app-page-data-panel
    title="Orchestration Queue"
    subtitle="Track the generated multi-hop warehouse route from source stock to customer delivery."
    [resultText]="filteredRows().length + ' of ' + rows.length + ' orchestrations'">
    @if (message) {
      <div class="notice">{{ message }}</div>
    }
    <div class="orchestration-toolbar">
      <input pInputText placeholder="Search number, source, status" [(ngModel)]="keyword">
      <p-select
        [options]="statusOptions"
        [(ngModel)]="status"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Status"
        appendTo="body"
        (onChange)="load()"></p-select>
    </div>

    <p-table [value]="filteredRows()" [loading]="isLoading" responsiveLayout="scroll" styleClass="workspace-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Orchestration</th>
          <th>Source</th>
          <th>Route</th>
          <th>Status</th>
          <th>Created</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <a class="orchestration-link" [routerLink]="['/transport-planning/orchestrations', row.crossDockOrchestrationId]">
              {{ row.crossDockOrchestrationNumber || ('#' + row.crossDockOrchestrationId) }}
            </a>
            <small>Parent release #{{ row.parentReleaseId || '-' }}</small>
          </td>
          <td>
            <strong>{{ row.sourceType || '-' }}</strong>
            <small>{{ row.sourceNumber || row.sourceId || '-' }}</small>
          </td>
          <td>
            <strong>{{ row.legCount || 0 }} leg{{ row.legCount === 1 ? '' : 's' }}</strong>
            <small>WH {{ row.sourceWarehouseId || '-' }} to WH {{ row.destinationWarehouseId || '-' }}</small>
          </td>
          <td>
            <p-tag [value]="row.status || 'PLANNED'" [severity]="severity(row.status)"></p-tag>
            <small>{{ row.validationMessage || row.validationStatus || 'Ready' }}</small>
          </td>
          <td>{{ date(row.createdAt) }}</td>
          <td class="text-right">
            <p-button label="Open" icon="pi pi-arrow-right" size="small" [outlined]="true" (onClick)="open(row)"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="6" class="empty-cell">No cross-dock orchestrations match the current filters.</td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
